import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import { getEquipmentList } from "../Actions/EquipmentManagementAPI";
import { FileCopy, Close, Height, HeightTwoTone, Folder } from "@material-ui/icons";


import {
  getCategoryList,
  getEquipmentTypeList,
  getEquipmentNameListAndId,
  getMakeList,
  getModelsList,
  getApplicableSeviceTypewithIdList,
} from "../Actions/helpersAPI";
import { AddAttachment, AddGAttachment, AddEquipManualAttachment } from "../Actions/AttachmentAPI";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";
import API from "../helpers/api";
import AutocompleteField from "react-autocomplete";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { getServiceTypeList } from "../Actions/CommonAPI";
import { toast } from "react-toastify";
import Role from "../helpers/role";
import $, { event } from "jquery";
import { deleteAttachmentInBucket } from "../Actions/CommonAPI";
import { DropzoneArea } from "material-ui-dropzone";
import i18n from "./DropdownLanguage/i18n";
import { OverlayTrigger, Popover } from "react-bootstrap";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let user = localStorage.getItem("UserRoles");
var fileDatas = [];

let searchData = {
  EquipmentId: 0,
  Equipment: "",
  MakeId: 0,
  ModelId: 0,
  Make: "",
  Model: "",
  ServiceType: "",
  EquipmentType: "",
  Category: "",
  ServiceTypeId: 0,
  EquipmentCategoryId: 0,
  capacity: "",
  PageNumber: 1,
  PageSize: 20,
};
class EquipmentUpdateScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      AddEquipmentYes: false,
      AddEquipmentNo: false,
      equipmentinfo: {
        equipmentId: 0,
        category: "",
        equipmentName: "",
        equipmentType: "",
        serviceTypes: [],
        isDeleted: false,
        attachmentName: "",
        isAddOnEquipment: "",
        modifiedBy: currentuser.name,
        capacity: "",
        files: "",
        attachmentType: "",
        attachmentGuid: "",
        guideAttachmentName: "",
        guideAttachmentGuid: "",
        otherAttachmentName: "",
        otherAttachmentGuid: "",
        equipmentCategoryTypeid: 0,
        selectedFilesAttachmentName: [],
        selectedFilesOtherAttachmentName: [],
        selectedFilesGuideAttachmentName: [],
      },
      equipguid: [],
      workprocguid: [],
      guideguid: [],
      annually: false,
      biannually: false,
      fiveyearly: false,
      tenyearly: false,
      applicableServiceType: [],
      modalIsOpen: false,
      isModelNew: true,
      models: [],
      EquipmentTypeList: [],
      CategoryTypeList: [],
      MakeAndModellist: [],
      MakeAndModelDetails: {
        makeApplicableServiceId: 0,
        modelApplicableServiceId: 0,
        equipmentId: 0,
        Id: 0,
        makeId: 0,
        makeName: "",
        modelId: 0,
        modelName: "",
        serviceTypeId: 0,
        serviceType: "",
        isShore: false,
        radioButton: "",
        isDeleted: false,
        modifiedBy: currentuser.name,
        euipmentManualFiles: [],
        workProcedureFiles: [],
        guidelinesFiles: []
      },
      selectedType: "",
      openEquipment: false,
      equipemntConfigTypeList: [],
      keydrop1: Date.now(),
      keydrop3: Date.now(),
      keydrop2: Date.now()
    };
    this.handleInputChange = this.handleInputChange.bind(this);

  }
  componentDidMount() {
    const { dispatch } = this.props;
    // dispatch(getCategoryList("category"));
    dispatch({ type: "SubBannerTitle", data: "Equipment Management" });
    this.getEquipmentList("equipmenttype");
    this.getCategoryList("category");
    this.getEquipmentType();
    // dispatch(getEquipmentTypeList("equipmenttype"));
    dispatch(getApplicableSeviceTypewithIdList());
    dispatch(getEquipmentNameListAndId());
    dispatch(getMakeList());
    dispatch(getModelsList());

  }
  getEquipmentList = (type) => {
    let url = `${API.lookupNamelist}?type=${type}`;
    axios.get(url).then((response) => {
      this.setState({ EquipmentTypeList: response.data.list });
    });
  };
  getCategoryList = (type) => {
    let url = `${API.lookupNamelist}?type=${type}`;
    axios.get(url).then((response) => {
      this.setState({ CategoryTypeList: response.data.list });
    });
  };
  getEquipmentType = () => {
    let url = `${API.equipmentLookups}?lookupType=${"EquipmentCategoryType"}`;
    axios.get(url).then((response) => {
      this.setState({ equipemntConfigTypeList: response.data });
    });
  }
  onTypeChange = (event, values) => {
    this.state.equipmentinfo.equipmentType = values;
    this.setState({});
  };
  onCategoryChange = (event, values) => {
    this.state.equipmentinfo.category = values;
    this.setState({});
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      dispatch,
      EquipmentDetail,
      attachmentDetail,
      GattachmentDetail,
      EquipManualattachmentDetail,
      EquipmentMakeModelCard,
    } = nextProps;
    if (EquipmentDetail && EquipmentDetail !== "") {
      prevState.equipmentinfo.equipmentId = EquipmentDetail.equipmentId;
      prevState.equipmentinfo.category = EquipmentDetail.category || null;
      prevState.equipmentinfo.equipmentName = EquipmentDetail.equipmentName;
      prevState.equipmentinfo.equipmentType =
        EquipmentDetail.equipmentType || null;
      prevState.equipmentinfo.serviceTypes = EquipmentDetail.serviceType;
      prevState.equipmentinfo.capacity = EquipmentDetail.capacity;
      prevState.equipmentinfo.attachmentName = EquipmentDetail.attachmentName;
      prevState.equipmentinfo.attachmentType = EquipmentDetail.attachmentType;
      prevState.equipmentinfo.attachmentGuid = EquipmentDetail.attachmentGuid;
      prevState.equipmentinfo.guideAttachmentName = EquipmentDetail.guideName;
      prevState.equipmentinfo.guideAttachmentGuid = EquipmentDetail.guideGuid;
      prevState.equipmentinfo.otherAttachmentName = EquipmentDetail.otherAttachmentName ? EquipmentDetail.otherAttachmentName : "";
      prevState.equipmentinfo.otherAttachmentGuid = EquipmentDetail.otherAttachmentGuid ? EquipmentDetail.otherAttachmentGuid : "";
      prevState.selectedType = EquipmentDetail.equipmentType;
      prevState.equipmentinfo.equipmentCategoryTypeid = EquipmentDetail.equipmentCategoryTypeId;
      prevState.equipmentinfo.isAddOnEquipment =
        EquipmentDetail.isAddOnEquipment;
      if (EquipmentMakeModelCard) {
        prevState.MakeAndModellist = EquipmentMakeModelCard;
      }
      if (EquipmentDetail.isAddOnEquipment) {
        prevState.AddEquipmentYes = true;
      } else {
        prevState.AddEquipmentNo = true;
      }
      /*  EquipmentDetail.serviceType.map((x) => {
        if (x.toLowerCase() === "annually") {
          prevState.annually = true;
        }
        if (x.toLowerCase() === "biannually") {
          prevState.biannually = true;
        }
        if (x.toLowerCase() === "fiveyearly") {
          prevState.fiveyearly = true;
        }
        if (x.toLowerCase() === "tenyearly") {
          prevState.tenyearly = true;
        }
      }); */
      dispatch({ type: "getEquipmentDetailSuccess", data: "" });
    }
    if (attachmentDetail) {
      prevState.equipmentinfo.attachmentName = attachmentDetail.FileName;
      prevState.equipmentinfo.attachmentGuid = attachmentDetail.Guid;
    } else if (GattachmentDetail) {
      prevState.equipmentinfo.guideAttachmentName = GattachmentDetail.FileName;
      prevState.equipmentinfo.guideAttachmentGuid = GattachmentDetail.Guid;
    }
    if (EquipManualattachmentDetail) {
      prevState.equipmentinfo.otherAttachmentName = EquipManualattachmentDetail.FileName;
      prevState.equipmentinfo.otherAttachmentGuid = EquipManualattachmentDetail.Guid;
    }
  }
  renderEquipmentTitle(state, val) {
    return state?.name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  UpdateEquipment() {
    const { dispatch, t } = this.props;
    
    let url = `${API.postEquipment}`;
    let allNotDeleted = this.state.MakeAndModellist.some(item => !item.hasOwnProperty('isDeleted') || item.isDeleted === false);
    console.log(allNotDeleted, 'check')
    if (this.state.equipmentinfo.equipmentName !== "" && this.state.equipmentinfo?.equipmentCategoryTypeid > 0 && this.state.equipmentinfo.capacity !== "" && this.state.equipmentinfo.equipmentType !== "" && this.state.equipmentinfo.equipmentType !== null && this.state.equipmentinfo.category !== "" && this.state.equipmentinfo.category !== null && this.props.EquipmentMakeModelCard.length > 0 && allNotDeleted) {
      let dataexist = {
        equipmentId: this.state.equipmentinfo.equipmentId,
        equipmentName: this.state.equipmentinfo.equipmentName ? this.state.equipmentinfo.equipmentName : "",
        equipmentType: this.state.equipmentinfo.equipmentType ? this.state.equipmentinfo.equipmentType : "",
        category: this.state.equipmentinfo.category ? this.state.equipmentinfo.category : "",
        capacity: this.state.equipmentinfo.capacity ? this.state.equipmentinfo.capacity : ""
      }
      let url1 = `${API.equipmentExist}`;
      axios
        .post(url1, dataexist)
        .then((response) => {
          if (response.data === true) {
            axios
              .put(url, this.state.equipmentinfo)
              .then((response) => {
                if (response.data) {
                  let url1 = `${API.getEquipmentApplicableServices}`;
                  axios
                    .put(url1, this.state.MakeAndModellist)
                    .then((res) => {

                      if (fileDatas.length > 0) {
                        this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                        fileDatas = [];
                      }
                      dispatch(getEquipmentList(searchData));
                      this.moveClientList();
                      toast.success(`${t("CommonText.CommonUpdate")}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });
                      dispatch({
                        type: "putEquipmentApplicableServiceSuccess",
                        data: res.data,
                      });
                    })
                    .catch((error) => {
                      // swal("Error!", "Something went wrong. Please try again.", "warning");
                      swal({
                        title: t('SwalError.ErrorTitle'), 
                        text: t("CommonText.500ErrorMessage"),  
                        icon: 'warning',  
                        buttons: {
                          confirm: {
                            text: t('confirmAlertMessage.Ok')
                          }
                        }
                      });
                      dispatch({
                        type: "putEquipmentApplicableServiceFailure",
                        error: "ERROR",
                      });
                    });
                }

                dispatch({
                  type: "putEquipmentDetailSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                // swal("Error!", "Something went wrong. Please try again.", "warning");
                swal({
                  title: t('SwalError.ErrorTitle'), 
                  text: t("CommonText.500ErrorMessage"),  
                  icon: 'warning',  
                  buttons: {
                    confirm: {
                      text: t('confirmAlertMessage.Ok')
                    }
                  }
                });
                dispatch({
                  type: "putEquipmentDetailFailure",
                  error: "ERROR",
                });
              });
          }
          else if (response.data === false) {
            // swal(
            //   "Error!",
            //   "Equipment name, equipment type, category, capacity already exist. Please change",
            //   "warning"
            // );
            swal({
              title: t('SwalError.ErrorTitle'), 
              text: t('SwalError.EquipmentExist'),  
              icon: 'warning',  
              buttons: {
                confirm: {
                  text: t('confirmAlertMessage.Ok')
                }
              }
            });
            this.state.equipmentinfo.equipmentName = "";
            this.setState({});
          }
          dispatch({
            type: "getEquipmentExistListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getEquipmentExistListFailure",
            data: "error",
          });
        });
    }
    else {
      if (this.state.equipmentinfo.equipmentName === "") {
        // swal("Error!", "Equipment name is mandatory.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentMandatory"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      } else if (this.state.equipmentinfo?.equipmentCategoryTypeid <= 0) {
        // swal("Error!", "Equipment Contract type is mandatory.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentContract"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
      else if (this.state.equipmentinfo.capacity == "") {
        // swal("Error!", "Equipment Capacity / Size is mandatory.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentCapacity"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
      else if (this.state.equipmentinfo.equipmentType === "" || this.state.equipmentinfo.equipmentType == null) {
        // swal("Error!", "Equipment type is mandatory.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentType"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
      else if (this.state.equipmentinfo.category === "" || this.state.equipmentinfo.category == null) {
        // swal("Error!", "Equipment Category is mandatory.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentCategory"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
      else if (allNotDeleted == false) {
        // swal("Error!", "Make is mandatory.", "warning");
        swal({
          title: t('SwalError.ErrorTitle'), 
          text: t("SwalError.EquipmentMake"),  
          icon: 'warning',  
          buttons: {
            confirm: {
              text: t('confirmAlertMessage.Ok')
            }
          }
        });
      }
    }
  }

  toDeleteOtherFile(idnum) {
    this.setState((prevState) => ({
      equipmentinfo: {
        ...prevState.equipmentinfo,
        selectedFilesOtherAttachmentName: prevState.equipmentinfo.selectedFilesOtherAttachmentName.filter((_, index) => (index !== idnum))
      },
      keydrop1: Date.now()
    }))
    console.log(this.state.equipmentinfo.selectedFilesOtherAttachmentName, 'check')
  }

  toDeleteequipguid(idnum) {
    this.setState((prevState) => ({
      equipguid: prevState.equipguid.filter((_, index) => index !== idnum),
    }));
  }

  toDeleteworkguid(idnum) {
    this.setState((prevState) => ({
      workprocguid: prevState.workprocguid.filter((_, index) => index !== idnum),
    }));
  }

  toDeleteguidelineguid(idnum) {
    this.setState((prevState) => ({
      guideguid: prevState.guideguid.filter((_, index) => index !== idnum),
    }));
  }

  toDeleteAttachmentFile(idnum) {
    this.setState((prevState) => ({
      equipmentinfo: {
        ...prevState.equipmentinfo,
        selectedFilesAttachmentName: prevState.equipmentinfo.selectedFilesAttachmentName.filter((_, index) => (index !== idnum))
      },
      keydrop2: Date.now()
    }))
  }

  // toDeleteGuideFile(idnum){
  //   // alert('deleted')
  //   const updatedFiles=prevState.equipmentinfo.selectedFilesGuideAttachmentName.filter((_,index)=>(index!==idnum))
  //   console.log(updatedFiles,'delete')

  //   this.setState((prevState)=>({
  //     equipmentinfo:{
  //       ...prevState.equipmentinfo,
  //       selectedFilesGuideAttachmentName:updatedFiles
  //     }
  //   }))
  // }

  toDeleteGuideFile(idnum) {
    this.setState((prevState) => {
      const updatedFiles = prevState.equipmentinfo.selectedFilesGuideAttachmentName.filter((_, index) => index !== idnum);

      // Log the updated state here to see the change
      console.log(updatedFiles, 'delete');

      return {
        equipmentinfo: {
          ...prevState.equipmentinfo,
          selectedFilesGuideAttachmentName: updatedFiles,
        },
        keydrop3: Date.now()
      };
    });
  }


  // handleDrop = (files) => {
  //   this.setState((prevState) => ({
  //     equipmentinfo: {
  //       ...prevState.equipmentinfo,
  //       selectedFilesGuideAttachmentName: [
  //         ...prevState.equipmentinfo.selectedFilesGuideAttachmentName,
  //         ...files,
  //       ],
  //     },
  //   }));
  // };

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "AddEquipmentyes") {
      this.state.equipmentinfo.isAddOnEquipment = true;
      this.setState({
        AddEquipmentYes: true,
        AddEquipmentNo: false,
      });
    } else if (nodeName === "AddEquipmentno") {
      this.state.equipmentinfo.isAddOnEquipment = false;
      this.setState({
        AddEquipmentYes: false,
        AddEquipmentNo: true,
      });
    } else if (nodeName === "annually") {
      if (e.target.checked) this.state.applicableServiceType.push("annually");
      else
        this.state.applicableServiceType =
          this.state.applicableServiceType.filter((r) => r !== "annually");
      this.setState({ annually: e.target.checked });
    } else if (nodeName === "biannually") {
      if (e.target.checked) this.state.applicableServiceType.push("biannually");
      else
        this.state.applicableServiceType =
          this.state.applicableServiceType.filter((r) => r !== "biannually");
      this.setState({ biannually: e.target.checked });
    } else if (nodeName === "fiveyearly") {
      if (e.target.checked) this.state.applicableServiceType.push("fiveyearly");
      else
        this.state.applicableServiceType =
          this.state.applicableServiceType.filter((r) => r !== "fiveyearly");
      this.setState({ fiveyearly: e.target.checked });
    } else if (nodeName === "tenyearly") {
      if (e.target.checked) this.state.applicableServiceType.push("tenyearly");
      else
        this.state.applicableServiceType =
          this.state.applicableServiceType.filter((r) => r !== "tenyearly");
      this.setState({ tenyearly: e.target.checked });
    } else if (nodeName == "equipmentCategoryTypeid") {
      this.state.equipmentinfo.equipmentCategoryTypeid = parseInt(e.target.value);
      this.setState({});
    } else {
      this.state.equipmentinfo[nodeName] = e.target.value;
      this.setState({});
    }
  }

  onSelectChange(item) {
    this.state.equipmentinfo.serviceTypes = item;
    this.setState({});
  }

  onRemoveChange(item) {
    this.state.equipmentinfo.serviceTypes = item;
    this.setState({});
  }

  handleDropFiles = (num, acceptedFiles) => {
    if (num === 1) {
      this.setState((prevState) => ({
        equipmentinfo: {
          ...prevState.equipmentinfo,
          selectedFilesOtherAttachmentName: [
            ...prevState.equipmentinfo.selectedFilesOtherAttachmentName,
            ...acceptedFiles,
          ],
        },
        // keydrop1: Date.now()
      }), () => { console.log(this.state.equipmentinfo) });

      // this.setState({
      //   equipmentinfo:{
      //     ...this.state.equipmentinfo,
      //     selectedFilesOtherAttachmentName:acceptedFiles
      //   }
      // })

    }

    else if (num === 2) {
      this.setState((prevState) => ({
        equipmentinfo: {
          ...prevState.equipmentinfo,
          selectedFilesAttachmentName: [
            ...prevState.equipmentinfo.selectedFilesAttachmentName,
            ...acceptedFiles,
          ],
        },
        // keydrop2: Date.now()
      }));
      // this.setState({
      //   equipmentinfo:{
      //     ...this.state.equipmentinfo,
      //     selectedFilesAttachmentName:acceptedFiles
      //   }
      // })
    }

    else if (num === 3) {
      this.setState((prevState) => ({
        equipmentinfo: {
          ...prevState.equipmentinfo,
          selectedFilesGuideAttachmentName: [
            ...prevState.equipmentinfo.selectedFilesGuideAttachmentName,
            ...acceptedFiles,
          ],
        },
        // keydrop3: Date.now()
      }));
    }
    //   this.setState({
    //     equipmentinfo:{
    //       ...this.state.equipmentinfo,
    //       selectedFilesGuideAttachmentName:acceptedFiles
    //     }
    //   })
    //  }

  };

  handleInputChangeMultipleFile(e, index) {
    const { dispatch, GattachmentDetail } = this.props;
    let nodeName = e.target.name;
    // dispatch(postAnnualCertificate(e.target.files[0], index));

    if (nodeName === "attachmentName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.state.equipmentinfo[nodeName] = e.target.files[0].name;
        this.state.files = e.target.files[0];
        this.state.equipmentinfo.selectedFilesAttachmentName = Array.from(e.target.files)
        this.setState({});
        this.props.dispatch(AddAttachment(e.target.files[0]));
        console.log(this.state.equipmentinfo.selectedFilesAttachmentName, 'attachemntName')
      } else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning");
        return;
      }
    } else if (nodeName === "guideAttachmentName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.state.equipmentinfo[nodeName] = e.target.files[0].name;
        this.state.files = e.target.files[0];
        this.state.equipmentinfo.selectedFilesGuideAttachmentName = Array.from(e.target.files)
        this.setState({});
        this.props.dispatch(AddGAttachment(e.target.files[0]));

      } else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning");
        return;
      }
    } else if (nodeName === "otherAttachmentName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.state.equipmentinfo[nodeName] = e.target.files[0].name;
        this.state.files = e.target.files[0];
        this.state.equipmentinfo.selectedFilesOtherAttachmentName = Array.from(e.target.files);
        console.log(this.state.equipmentinfo.selectedFilesOtherAttachmentName, 'files');
        this.setState({});
        this.props.dispatch(AddEquipManualAttachment(e.target.files[0]));
      }
      else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning");
        return;
      }
    }
    // else if (nodeName === "documentname") {
    //   let filename = e.target.files[0].name;
    //   let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
    //   if (regex.test(filename)) {
    //     this.state.equipmentinfo[nodeName] = e.target.files[0].name;
    //     this.state.files = e.target.files[0];
    //     this.setState({});
    //     this.props.dispatch(AddnewdocAttachmnt(e.target.files[0]));
    //   } else {
    //     swal(
    //       "Error!",
    //       "Please upload the file without special characters.",
    //       "warning");
    //     return;
    //   }
    // }
  }

  // onDragOver=(event)=>{
  //   event.preventDefault()
  //   event.stopPropagation()
  // }

  // onDrop=(event)=>{
  //   event.preventDefault()
  //   event.stopPropagation()

  //   const dragFiles=event.dataTransfer.files
  //   dragFiles=Array.from(dragFiles)
  //   console.log(dragFiles,'dragq')
  //   this.setState(prevState=>({equipmentinfo:
  //     { ...prevState.equipmentinfo,
  //       selectedFilesAttachmentName:dragFiles}
  //   }))
  //   console.log(this.equipmentinfo.selectedFilesAttachmentName,'console')
  // }


  ClearFiles = (num) => {
    if (num === 3) {
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesGuideAttachmentName: []
        },
        guideguid: []
      }))
    }

    else if (num === 2) {
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesAttachmentName: []
        },
        workprocguid: []
      }))
    }

    //   else if(num===1){
    //     this.setState(prevState=>({equipmentinfo:
    //       { ...prevState.equipmentinfo,
    //         selectedFilesOtherAttachmentName:[]}
    //     }))
    //     console.log(this.state.equipmentinfo.selectedFilesOtherAttachmentName,'check')
    //   }
    // }
    else if (num === 1) {
      this.setState(prevState => {
        const updatedFiles = [];


        console.log(updatedFiles, 'checkdel');

        return {
          equipmentinfo: {
            ...prevState.equipmentinfo,
            selectedFilesOtherAttachmentName: updatedFiles,
          },
          equipguid: []
        };
      });
    }
  }


  ClearInput = (e) => {
    if (e === 1) {
      let obj1 = {
        filename: this.state.equipmentinfo.attachmentName,
        guid: this.state.equipmentinfo.attachmentGuid,
      }
      console.log(fileDatas);
      fileDatas.push(obj1);
      //this.props.dispatch(deleteAttachmentInBucket(this.state.equipmentinfo.attachmentGuid,this.state.equipmentinfo.attachmentName));
      this.state.equipmentinfo.attachmentName = "";
      this.state.equipmentinfo.files = "";
      this.state.equipmentinfo.attachmentGuid = "";
      this.props.dispatch({
        type: "AttchmentUploaded",
        data: "",
      });
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesAttachmentName: []
        }
      }))
    }
    if (e === 2) {
      let obj2 = {
        filename: this.state.equipmentinfo.guideAttachmentName,
        guid: this.state.equipmentinfo.guideAttachmentGuid,
      }
      console.log(fileDatas);
      fileDatas.push(obj2);
      //this.props.dispatch(deleteAttachmentInBucket(this.state.equipmentinfo.guideAttachmentGuid,this.state.equipmentinfo.guideAttachmentName));
      this.state.equipmentinfo.guideAttachmentName = "";
      this.state.equipmentinfo.files = "";
      this.state.equipmentinfo.guideAttachmentGuid = "";
      this.props.dispatch({
        type: "GAttchmentUploaded",
        data: "",
      });
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesGuideAttachmentName: []
        }
      }))

    }
    if (e === 3) {
      let obj3 = {
        filename: this.state.equipmentinfo.otherAttachmentName,
        guid: this.state.equipmentinfo.otherAttachmentGuid,
      }
      fileDatas.push(obj3);
      this.state.equipmentinfo.otherAttachmentName = "";
      this.state.equipmentinfo.otherAttachmentGuid = "";
      this.props.dispatch({
        type: "EquipManualAttchmentUploaded",
        data: "",
      });
      this.setState(prevState => ({
        equipmentinfo:
        {
          ...prevState.equipmentinfo,
          selectedFilesOtherAttachmentName: []
        }
      }))
    }
  };
  handleSelectChange(value, field, item) {
    const { dispatch } = this.props;
    this.state.MakeAndModelDetails.makeId = item;
    this.state.MakeAndModelDetails.makeName = value;
    this.setState({});
    dispatch(getModelsList(value));

    this.showModal(0, true);
  }
  showModal = (ModelId, isModelNew, equip, work, guide) => {
    const { dispatch } = this.props;
    var arrayStroage = this.state.MakeAndModellist;
    var arrayLength = arrayStroage.length;
    if (ModelId > 0) {
      let response = this.state.MakeAndModellist.filter(
        (item) =>
          item.Id === ModelId || item.modelApplicableServiceId === ModelId
      );
      let editModelDetails = response[0];
      if (isModelNew === false) {
        dispatch(getModelsList(editModelDetails.makeName));
      }
      this.setState(
        {
          modalIsOpen: !this.state.modalIsOpen,
          isModelNew: isModelNew,
          MakeAndModelDetails: {
            makeApplicableServiceId: editModelDetails.makeApplicableServiceId,
            modelApplicableServiceId: editModelDetails.modelApplicableServiceId,
            equipmentId: editModelDetails.equipmentId,
            Id: parseInt(editModelDetails.Id),
            makeId: editModelDetails.makeId,
            makeName: editModelDetails.makeName,
            modelId: editModelDetails.modelId,
            modelName: editModelDetails.modelName,
            serviceType: editModelDetails.serviceType,
            serviceTypeId: editModelDetails.serviceTypeId,
            radioButton: editModelDetails.isShore ? "Shore" : "Ship",
            isShore: editModelDetails.isShore,
            isDeleted: false,
            modifiedBy: currentuser.name,
          },
          equipguid: equip,
          workprocguid: work,
          guideguid: guide
        },
        () => console.log(this.state.isModelNew)
      );
    } else {
      this.setState(
        {
          isModelNew: isModelNew,
          MakeAndModelDetails: {
            makeApplicableServiceId: 0,
            modelApplicableServiceId: 0,
            equipmentId: this.state.equipmentinfo.equipmentId,
            Id: arrayLength >= 0 ? arrayLength + 1 : 0,
            makeId: this.state.MakeAndModelDetails.makeId,
            makeName: this.state.MakeAndModelDetails.makeName,
            modelId: 0,
            modelName: "",
            serviceType: "",
            serviceTypeId: 0,
            radioButton: "",
            isShore: false,
            isDeleted: false,
            modifiedBy: currentuser.name,
          },
          modalIsOpen: !this.state.modalIsOpen,
        },
        () => {
          /*  console.log("addservice", this.state.MakeAndModelDetails);
           console.log("model", this.state.modalIsOpen); */
          this.ClearModel();
        }
      );
    }
  };

  ModelValidation = () => {
    const { t } = this.props;
    if (
      $("#ModelCode").val() === "" ||
      $("#ServiceCode").val() === "" ||
      this.state.MakeAndModelDetails.radioButton === ""
      // this.state.equipmentinfo.selectedFilesOtherAttachmentName.length === 0 ||
      // this.state.equipmentinfo.selectedFilesAttachmentName.length === 0 ||
      // this.state.equipmentinfo.selectedFilesGuideAttachmentName.length === 0
      // $("#selectedFilesOtherAttachmentName").val() === "" 
      // $('#selectedFilesAttachmentName').val()=== ""   ||
      // $("#selectedFilesGuideAttachmentName").val()=== ""
    ) {
      if ($("#ModelCode").val() === "") {
        $("#ModelCodeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#ModelCodeErrMsg").text("");
      }
      if ($("#ServiceCode").val() === "") {
        $("#ServiceCodeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      } else {
        $("#ServiceCodeErrMsg").text("");
      }
      if (this.state.MakeAndModelDetails.radioButton === "") {
        $("#TypeCodeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
      }
      else {
        $("#TypeCodeErrMsg").text("");
      }
      // if (this.state.equipmentinfo.selectedFilesOtherAttachmentName.length === 0) {
      //   $("#selectedFilesOtherAttachmentNameErr").text(`${t("ErrorMessage.RequiredMsg")}`);
      // }
      // else {
      //   $("#selectedFilesOtherAttachmentNameErr").text("");
      // }
      // if (this.state.equipmentinfo.selectedFilesAttachmentName.length === 0) {
      //   $("#selectedFilesAttachmentNameErr").text(`${t("ErrorMessage.RequiredMsg")}`);
      // }
      // else {
      //   $("#selectedFilesAttachmentNameErr").text("");
      // }
      // if (this.state.equipmentinfo.selectedFilesGuideAttachmentName.length === 0) {
      //   $("#selectedFilesGuideAttachmentNameErr").text(`${t("ErrorMessage.RequiredMsg")}`);
      // }
      // else {
      //   $("#selectedFilesGuideAttachmentNameErr").text("");
      // }
      return;
    } else {
      $("#ModelCodeErrMsg").text("");
      $("#ServiceCodeErrMsg").text("");
      $("#TypeCodeErrMsg").text("");
      $("#selectedFilesGuideAttachmentNameErr").text("");
      $("#selectedFilesAttachmentNameErr").text("");
      $("#selectedFilesOtherAttachmentNameErr").text("");
    }
    this.UploadModel();
  };

  uploadFiles = async (files) => {
    const url = `${API.AttachmentAPI}`;
    const successfulUploads = [];
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await axios.post(url, formData);
        const { Guid, FileName } = response.data;
        successfulUploads.push({ guid: Guid, filename: FileName });
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
    return successfulUploads;
  };

  checkdocvalid = (product, id, list) => {
    const matchingObject = list.find(obj => obj.makeId === id);
    let flag = true;
    if (matchingObject && Object.keys(matchingObject).length > 0 && id != 0) {
      // if ((matchingObject.equipmentManual.length !== product.equipmentManual.length &&
      //   matchingObject.workProcedure.length !== product.workProcedure.length &&
      //   matchingObject.guideLines.length !== product.guideLines.length)
      // ) {
      if (this.compareArrays(matchingObject.equipmentManual, product.equipmentManual) &&
        this.compareArrays(matchingObject.workProcedure, product.workProcedure) &&
        this.compareArrays(matchingObject.guideLines, product.guideLines)) {
        flag = false;
      }
      // }

    }
    return flag;
  }

  compareArrays(arr1, arr2) {
    // Check if both arrays have the same length
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Sort both arrays by a common property (e.g., 'filename' or 'guid') for accurate comparison
    const sortedArr1 = [...arr1].sort((a, b) => a.filename.localeCompare(b.filename));
    const sortedArr2 = [...arr2].sort((a, b) => a.filename.localeCompare(b.filename));

    // Compare each object in both arrays
    for (let i = 0; i < sortedArr1.length; i++) {
      const obj1 = sortedArr1[i];
      const obj2 = sortedArr2[i];

      // Check if filename and guid match
      if (obj1.filename !== obj2.filename || obj1.guid !== obj2.guid) {
        return false; // If any property doesn't match, arrays are not the same
      }
    }

    // If no mismatch found, arrays are the same
    return true;
  }

  UploadModel = async () => {
    var equipmentManualguid = await this.uploadFiles(this.state.equipmentinfo.selectedFilesOtherAttachmentName);
    var workguid = await this.uploadFiles(this.state.equipmentinfo.selectedFilesAttachmentName);
    var guideid = await this.uploadFiles(this.state.equipmentinfo.selectedFilesGuideAttachmentName);
    const { dispatch } = this.props;
    var product = {
      makeApplicableServiceId: parseInt(this.state.MakeAndModelDetails.makeApplicableServiceId),
      modelApplicableServiceId: parseInt(this.state.MakeAndModelDetails.modelApplicableServiceId),
      equipmentId: parseInt(this.state.MakeAndModelDetails.equipmentId),
      Id: parseInt(this.state.MakeAndModelDetails.Id),
      makeId: parseInt(this.state.MakeAndModelDetails.makeId),
      makeName: this.state.MakeAndModelDetails.makeName,
      modelId: parseInt(this.state.MakeAndModelDetails.modelId),
      modelName: this.state.MakeAndModelDetails.modelName,
      serviceTypeId: parseInt(this.state.MakeAndModelDetails.serviceTypeId),
      serviceType: this.state.MakeAndModelDetails.serviceType,
      isShore: this.state.MakeAndModelDetails.isShore,
      radioButton: this.state.MakeAndModelDetails.radioButton,
      isDeleted: this.state.MakeAndModelDetails.isDeleted,
      modifiedBy: this.state.MakeAndModelDetails.modifiedBy,
      equipmentManual: [...this.state.equipguid, ...equipmentManualguid],
      workProcedure: [...this.state.workprocguid, ...workguid],
      guideLines: [...this.state.guideguid, ...guideid],
      isEquipmentManualUpdate: true,
      isWorkProcedureUpdate: true,
      isGuideLinesUpdate: true,
      modifiedBy: this.state.equipmentinfo.modifiedBy
    };
    var booldoc = this.checkdocvalid(product, product.makeId, this.state.MakeAndModellist);
    let GetModel = this.state.MakeAndModellist;
    let temp = [];
    if (product.modelApplicableServiceId !== 0) {
      temp = GetModel.filter((j) => product.modelApplicableServiceId === j.modelApplicableServiceId) || [];
    } else {
      temp = GetModel.filter((j) => j.Id === product.Id) || [];
    }
    /* console.log(GetModel,product) */
    if (temp.length > 0) {
      const result = GetModel.filter((item) => item.isDeleted !== true)
      let servicedata = [];
      if (result.length > 0) {
        servicedata = result.filter(k => (k.serviceTypeId === product.serviceTypeId) && (k.makeId === product.makeId) && (k.modelId === product.modelId) && ((k.isShore == true && "Shore" === product.radioButton) || (k.isShore === false && "Ship" === product.radioButton)));  /* k.isShore==true ?"Shore": k.isShore===false ?"Ship":"" === product.radioButton */
      } else {
        servicedata = GetModel.filter(k => (k.serviceTypeId === product.serviceTypeId) && (k.makeId === product.makeId) && (k.modelId === product.modelId) && ((k.isShore == true && "Shore" === product.radioButton) || (k.isShore === false && "Ship" === product.radioButton)))
      }
      /*    console.log("service",servicedata) */
      if (servicedata.length > 0 && !booldoc) {
        var str = "Make,Model,Service year and Service type";
        swal(
          "Error!",
          str +
          " already exist. Please change the" + " " +
          str.toLocaleLowerCase() + " " + ".",
          "warning"
        );
      } else {
        GetModel.forEach((ele, index) => {
          if (ele.modelApplicableServiceId !== 0) {
            if (ele.modelApplicableServiceId === product.modelApplicableServiceId) {
              GetModel[index] = product;
            }
          } else {
            if (ele.Id === product.Id) {
              GetModel[index] = product;
            }
          }
        });
      }
    } else {
      const result = GetModel.filter((item) => item.isDeleted !== true)
      let servicedata = result.filter((k) => (k.serviceTypeId === product.serviceTypeId) && (k.makeId === product.makeId) && (k.modelId === product.modelId))
      /*  console.log("service",servicedata) */
      if (servicedata.length > 0) {
        var str = "Make,Model,Service year and Service type";
        swal(
          "Error!",
          str +
          " already exist. Please change the" + " " +
          str.toLocaleLowerCase() + " " + ".",
          "warning"
        );
      } else {
        GetModel.push(product);
      }
    }
    var Information = JSON.stringify(GetModel);
    dispatch({
      type: "getMakeAndModelApplicableServices",
      data: this.state.MakeAndModellist,
    });
    this.state.MakeAndModelDetails.makeName = "";
    this.setState(
      {
        modalIsOpen: false,
      },
      () => {
        this.ClearModel();
      }
    );
  };

  handleInputChanges(e, field) {
    this.state.MakeAndModelDetails[field] = e.target.value;
    this.setState({});
  }
  handleInputValue(values) {
    this.setState({ selectedType: values });
  }
  ClearModel = () => {
    var arrayStroage = this.state.MakeAndModellist;
    var arrayLength = arrayStroage.length;
    this.setState({
      MakeAndModelDetails: {
        makeApplicableServiceId:
          this.state.MakeAndModelDetails.makeApplicableServiceId,
        modelApplicableServiceId:
          this.state.MakeAndModelDetails.modelApplicableServiceId,
        equipmentId: this.state.equipmentinfo.equipmentId,
        Id: arrayLength >= 0 ? arrayLength + 1 : 0,
        serviceTypeId: 0,
        makeId: this.state.MakeAndModelDetails.makeId,
        makeName: this.state.MakeAndModelDetails.makeName,
        modelId: 0,
        modelName: "",
        isShore: false,
        radioButton: "",
        isDeleted: false,
      },
      equipguid: [],
      workprocguid: [],
      guideguid: []
    });
    this.setState((prevState) => ({
      equipmentinfo: {
        ...prevState.equipmentinfo,
        selectedFilesAttachmentName: [],
        selectedFilesGuideAttachmentName: [],
        selectedFilesOtherAttachmentName: [],
      },
    }));
  };
  handleRadioButtonChanges = (e, i) => {
    var lineitems = this.state.MakeAndModelDetails;
    lineitems[e.target.name] = e.target.value;
    if (e.target.value === "Shore") {
      lineitems["isShore"] = true;
    } else {
      lineitems["isShore"] = false;
    }
    this.setState({});
  };
  handleSelectYear = (e, i) => {
    if (e.target.name === "modelId") {
      var value = this.props.ModelList.filter(
        (key) => key.id === parseInt(e.target.value)
      );
      this.state.MakeAndModelDetails.modelId = value[0].id;
      this.state.MakeAndModelDetails.modelName = value[0].name;
      this.setState({});
    }
    if (e.target.name === "serviceTypeId") {
      var value = this.props.applicableServiceTypeList.filter(
        (key) => key.item === parseInt(e.target.value)
      );
      this.state.MakeAndModelDetails.serviceTypeId = value[0].item;
      this.state.MakeAndModelDetails.serviceType = value[0].serviceTypes;
      this.setState({});
    }
  };

  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  deleteModel = (item) => {
    const { t } = this.props;
    this.state.openEquipment = true;
    this.setState({})
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            item.isDeleted = true;
            this.setState({ openEquipment: false });
            console.log(this.state.MakeAndModellist, 'check')
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {
            this.state.openEquipment = false;
            this.setState({})
          },
        },
      ],
    });
  };

  render() {
    const { ModelList, applicableServiceTypeList, t } = this.props;

    return (
      <div className="pb-3">
        <Modal
          size="xl"
          show={this.state.modalIsOpen}
          onHide={() => {
            this.showModal(0, true);
          }}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          className="borderCondition"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("content.Servicetype")}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className={"col-lg-4"}>
                <label className="form-label required">{t("ShipEquipmentStatusScreen.Model")}</label>
                <br></br>
                <select
                  className="form-control"
                  id="ModelCode"
                  name="modelId"
                  value={this.state.MakeAndModelDetails.modelId}
                  onChange={(e) => this.handleSelectYear(e)}
                >
                  <option value="">{t("MakeAndModelScreen.SelectModel")}</option>
                  {ModelList?.map((item, index) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
                <span id="ModelCodeErrMsg" className="spanErrMsg"></span>
              </div>
              <div className={"col-lg-4"}>
                <label className="form-label required">{t("content.Servicetype")}</label>
                <br></br>
                <select
                  className="form-control"
                  name="serviceTypeId"
                  value={this.state.MakeAndModelDetails.serviceTypeId}
                  id="ServiceCode"
                  onChange={(e) => this.handleSelectYear(e)}
                >
                  <option value="">{t("EquipmentManagementScreenContent.SelectServiceType")}</option>
                  {applicableServiceTypeList?.map((name) => (
                    <option value={name.item}>{name.serviceTypes}</option>
                  ))}
                </select>
                <span id="ServiceCodeErrMsg" className="spanErrMsg"></span>
              </div>
              <div className={"col-lg-4"}>
                <label className="form-label required">{t("ShipEquipmentStatusScreen.Type")}</label>
                <br></br>
                <div className="mr-1">
                  <RadioGroup
                    className="radio-value"
                    row
                    name="radioButton"
                    id="TypeCode"
                    value={this.state.MakeAndModelDetails.radioButton}
                    onChange={(e) => this.handleRadioButtonChanges(e)}
                  >
                    <FormControlLabel
                      className="mt-0"
                      value="Ship"
                      control={<Radio color="default" size="small" />}
                      label={t("Generateservicerequestcontent.Ship")}
                    />
                    <FormControlLabel
                      className="mt-0"
                      value="Shore"
                      control={<Radio color="default" size="small" />}
                      label={t("Generateservicerequestcontent.Shore")}
                    />
                  </RadioGroup>
                  <span id="TypeCodeErrMsg" className="spanErrMsg"></span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4">
                <label className="form-label">{t("EquipmentManagementScreenContent.EquipmentManual")}</label>
                <br></br>
                <div class="input-group ">
                  <div class="input-group-prepend">
                    {/* <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                type="file"
                                multiple
                                style={{ marginRight: 40 }}
                                name="otherAttachmentName"
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span> */}
                    <div style={{ display: "flex", position: "relative" }}>
                      <Folder className="folderIcon" />
                      <DropzoneArea
                        key={this.state.keydrop1}
                        id="selectedFilesOtherAttachmentName"
                        onDrop={(files) => this.handleDropFiles(1, files)}
                        showPreviewsInDropzone={false}
                        maxFileSize={10000000}
                        dropzoneText={t('CommonText.UploadText')}
                        filesLimit={10}
                        style={{ height: '20px', position: 'absolute' }}
                        sx={{

                          '& .MuiDropzonePreviewList-root': {
                            display: 'none',
                          },
                          '& .MuiDropzoneArea-root': {
                            minHeight: '20px !important',
                          },

                        }}
                      />
                    </div>
                    {/* <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={this.state.equipmentinfo.selectedFilesOtherAttachmentName.length !==0?(
                              this.state.equipmentinfo.selectedFilesOtherAttachmentName.length + " Files" ):( " ")
                            }
                          /> */}
                  </div>

                  {/* {this.state.equipmentinfo.otherAttachmentName ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(3)}
                              ></i>
                            </div>
                          ) : (
                            ""
                          )} */}
                </div>
                <div>
                  <span className="removeall" onClick={() => this.ClearFiles(1)}>{t("EquipmentManagementScreenContent.RemoveAll")}</span>
                </div>
                <span id="selectedFilesOtherAttachmentNameErr" className="spanErrMsg"></span>
                <div className={"displaybox"}>
                  <br></br>
                  <table style={{ border: 'none' }}>

                    <tbody>
                      {this.state.equipguid.map((fileName, index) => (

                        <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.filename}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteequipguid(index)} /></td> </tr>
                      ))}
                      {this.state.equipmentinfo.selectedFilesOtherAttachmentName.map((fileName, index) => (

                        <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.name}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteOtherFile(index)} /></td> </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-4">
                <label className="form-label">{t("EquipmentManagementScreenContent.Workprocedure")}</label>
                <br></br>
                <div class="input-group ">
                  <div class="input-group-prepend">
                    {/* <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                
                                type="file"
                                multiple
                                id="files"
                                style={{ marginRight: 40 }}
                                name="attachmentName"
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span> */}
                    <div style={{ display: "flex", position: "relative" }}>
                      <Folder className="folderIcon" />
                      <DropzoneArea
                        key={this.state.keydrop2}
                        id="selectedFilesAttachmentName"
                        onDrop={(files) => this.handleDropFiles(2, files)}
                        showPreviewsInDropzone={false}
                        maxFileSize={10000000}
                        dropzoneText={t('CommonText.UploadText')}
                        filesLimit={10}
                        style={{ height: '20px', position: 'absolute' }}
                        sx={{

                          '& .MuiDropzonePreviewList-root': {
                            display: 'none',
                          },
                          '& .MuiDropzoneArea-root': {
                            minHeight: '20px !important',
                          },
                        }}
                      />
                    </div>
                    {/* <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={this.state.equipmentinfo.selectedFilesAttachmentName.length !==0?(
                                this.state.equipmentinfo.selectedFilesAttachmentName.length + " Files" ):( " ")
                            }
                          /> */}
                  </div>

                  {/* {this.state.equipmentinfo.attachmentName ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(1)}
                              ></i>
                              
                            </div>
                          ) : (
                            ""
                          )} */}
                </div>
                <div>
                  <span className="removeall" onClick={() => this.ClearFiles(2)}>{t("EquipmentManagementScreenContent.RemoveAll")}</span>
                </div>
                <span id="selectedFilesAttachmentNameErr" className="spanErrMsg"></span>
                <div className={"displaybox"}>
                  <br></br>
                  <table style={{ border: 'none' }}>
                    <tbody>
                      {this.state.workprocguid.map((fileName, index) => (

                        <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.filename}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteworkguid(index)} /></td> </tr>
                      ))}
                      {this.state.equipmentinfo.selectedFilesAttachmentName.map((fileName, index) => (
                        <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.name}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteAttachmentFile(index)} /></td></tr>
                      ))}</tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-4">
                <label className="form-label">{t("EquipmentManagementScreenContent.GuideLines")}</label>
                <br></br>
                <div class="input-group">
                  <div class="input-group-prepend">
                    {/* <span class="input-group-text">
                                {t("CommonText.BrowseFile")}
                               
                                <input
                                  type="file"
                                  multiple
                                  id="files"
                                  style={{ marginRight: 40 }}
                                  name="guideAttachmentName"
                                  onChange={(e) =>
                                    this.handleInputChangeMultipleFile(e)
                                  }
                                  onClick={(event) => {
                                    event.currentTarget.value = null;
                                  }}
                                />
                              </span> */}
                    <div style={{ display: "flex", position: "relative" }}>
                      <Folder className="folderIcon" />
                      <DropzoneArea
                        key={this.state.keydrop3}
                        id="selectedFilesGuideAttachmentName"
                        onDrop={(files) => this.handleDropFiles(3, files)}
                        showPreviewsInDropzone={false}
                        maxFileSize={10000000}
                        dropzoneText={t('CommonText.UploadText')}
                        filesLimit={10}
                        style={{ height: '20px', position: 'absolute' }}
                        sx={{
                          '& .MuiDropzonePreviewList-root': {
                            display: 'none',
                          },
                          '& .MuiDropzoneArea-root': {
                            minHeight: '20px !important',
                          },
                        }}
                      />
                    </div>
                    {/* <input
                              multiple
                              type="text"
                              class="form-control"
                              placeholder=""
                              value={this.state.equipmentinfo.selectedFilesGuideAttachmentName.length !==0?(
                                this.state.equipmentinfo.selectedFilesGuideAttachmentName.length + " Files" ):( " ")
                            }
                            /> */}
                    {/* {this.state.equipmentinfo.guideAttachmentName ? (
                              <div
                                class="input-group-append"
                                style={{ cursor: "pointer" }}
                              >
                                <i
                                  class="fa fa-times input-group-text padding-top-9px"
                                  aria-hidden="true"
                                  onClick={() => this.ClearInput(2)}
                                ></i>
                              </div>
                            ) : (
                              ""
                            )} */}

                  </div>

                </div>
                <div>
                  <span className="removeall" onClick={() => this.ClearFiles(3)}>{t("EquipmentManagementScreenContent.RemoveAll")}</span>
                </div>
                <span id="selectedFilesGuideAttachmentNameErr" className="spanErrMsg"></span>
                <div className={"displaybox"}>
                  <br></br>
                  <table style={{ border: 'none' }}>
                    <tbody>
                      {this.state.guideguid.map((fileName, index) => (

                        <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.filename}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteguidelineguid(index)} /></td> </tr>
                      ))}
                      {this.state.equipmentinfo.selectedFilesGuideAttachmentName.map((fileName, index) => (
                        <tr key={index}><td><FileCopy className="filecopy" /></td><td>{fileName.name} </td><td><Close className="equipcloseicon" onClick={() => this.toDeleteGuideFile(index)} /></td></tr>
                      ))}</tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="row">
              {/* <div className={"col-lg-4 displaybox"}>
                <br></br>
                <table style={{ border: 'none' }}>

                  <tbody>
                    {this.state.equipguid.map((fileName, index) => (

                      <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.filename}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteequipguid(index)} /></td> </tr>
                    ))}
                    {this.state.equipmentinfo.selectedFilesOtherAttachmentName.map((fileName, index) => (

                      <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.name}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteOtherFile(index)} /></td> </tr>
                    ))}
                  </tbody>
                </table>
              </div> */}

              {/* <div className={"col-lg-4 displaybox"}>
                <br></br>
                <table style={{ border: 'none' }}>
                  <tbody>
                    {this.state.workprocguid.map((fileName, index) => (

                      <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.filename}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteworkguid(index)} /></td> </tr>
                    ))}
                    {this.state.equipmentinfo.selectedFilesAttachmentName.map((fileName, index) => (
                      <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.name}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteAttachmentFile(index)} /></td></tr>
                    ))}</tbody>
                </table>
              </div> */}

              {/* <div className={"col-lg-4 displaybox"}>
                <br></br>
                <table style={{ border: 'none' }}>
                  <tbody>
                    {this.state.guideguid.map((fileName, index) => (

                      <tr key={index} ><td><FileCopy className="filecopy" /></td><td>{fileName.filename}</td> <td><Close className="equipcloseicon" onClick={() => this.toDeleteguidelineguid(index)} /></td> </tr>
                    ))}
                    {this.state.equipmentinfo.selectedFilesGuideAttachmentName.map((fileName, index) => (
                      <tr key={index}><td><FileCopy className="filecopy" /></td><td>{fileName.name} </td><td><Close className="equipcloseicon" onClick={() => this.toDeleteGuideFile(index)} /></td></tr>
                    ))}</tbody>
                </table>
              </div> */}

            </div>

            <div className="row">
              <div className="col-lg-6 ml-auto">
                <div
                  className="search-btn-col pt-3"
                  style={{ textAlign: "end" }}
                >
                  <button
                    type="button"
                    id="SBMCAdd"
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-2"
                    style={{ backgroundColor: "rgb(26, 52, 100)" }}
                    onClick={() => this.ModelValidation()}
                  >
                    {this.state.isModelNew ? `${t("ShipManagementContent.Add")}` : `${t("EquipmentServiceTypes.Update")}`}
                  </button>
                  <button
                    type="button"
                    className="btn btn-light text-uppercase txtside-btn txtht-btn mt-2 ml-2"
                    data-dismiss="modal"
                    onClick={() => this.showModal(0, true)}
                  >
                    {t("ComplianceandBudgetScreen.Cancel")}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const {
      showSidePane,
      EquipmentTypeList,
      CategoryList,
      serviceTypeList,
      ModelList,
      MakeList,
      Loading,
      t
    } = this.props;
    console.log(
      "Equipment",
      this.state.equipmentinfo,
      this.props.EquipmentTypeList
    );
    return (
      <div className="full-height">
        <div className="px-4 pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div className="row search-filter-box">
                  <div className="col-lg-12">
                    <div
                      className="card mt-2 MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t("EquipmentManagementScreenContent.BasicInformation")}
                        </h5>
                      </div>
                    </div>
                    <div className="row search-filter-box">
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label fontstyle required">{t("EquipmentManagementScreenContent.Name")}</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="equipmentName"
                          placeholder={t("EquipmentManagementScreenContent.Name")}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.equipmentinfo.equipmentName}
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label required">{t("ComplianceandBudgetScreen.Type")}</label>
                        <br></br>
                        <Autocomplete
                          value={this.state.equipmentinfo.equipmentType || ""}
                          options={this.state.EquipmentTypeList ?? []}
                          getOptionLabel={(option) => option || ""}
                          style={{ marginTop: "-17px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          onChange={(event, value) => {
                            this.onTypeChange(event, value);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="form-control"
                              placeholder={t("EquipmentManagementScreenContent.SelectEquipmentType")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label required">{t("TopPaneContent.Category")}</label>
                        <br></br>
                        <Autocomplete
                          value={this.state.equipmentinfo.category || ""}
                          options={this.state.CategoryTypeList ?? []}
                          getOptionLabel={(option) => option || ""}
                          style={{ marginTop: "-17px" }}
                          noOptionsText={t("CommonText.NoOption")}
                          size={"small"}
                          onChange={(e, value) =>
                            this.onCategoryChange(e, value)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="form-control"
                              placeholder={t("EquipmentManagementScreenContent.SelectCategory")}
                              margin="normal"
                            />
                          )}
                        />
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label required">{t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")}</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="capacity"
                          placeholder={t("EquipmentManagementScreenContent.Capacity/Size")}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.equipmentinfo.capacity}
                        ></input>
                      </div>
                      {/* <div
                        className={
                          showSidePane
                            ? "col-lg-6 hide-pic-option"
                            : "col-lg-4 hide-pic-option"
                        }
                      >
                        <label className="form-label">{t("EquipmentManagementScreenContent.EquipmentManual")}</label>
                        <br></br>
                        <div class="input-group ">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                type="file"
                                multiple
                                id="files"
                                style={{ marginRight: 40 }}
                                name="otherAttachmentName"
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span>
                          </div>
                          <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={this.state.equipmentinfo.otherAttachmentName}
                          />
                          {this.state.equipmentinfo.otherAttachmentName ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(3)}
                              ></i>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div
                        className={
                          showSidePane
                            ? "col-lg-6 hide-pic-option"
                            : "col-lg-4 hide-pic-option"
                        }
                      >
                        <label className="form-label">{t("EquipmentManagementScreenContent.Workprocedure")}</label>
                        <br></br>
                        <div class="input-group ">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                type="file"
                                multiple
                                id="files"
                                style={{ marginRight: 40 }}
                                name="attachmentName"
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span>
                          </div>
                          <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={this.state.equipmentinfo.attachmentName}
                          />
                          {this.state.equipmentinfo.attachmentName ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(1)}
                              ></i>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {user === Role.mmpladmin ? (
                        <div
                          className={
                            showSidePane
                              ? "col-lg-6 hide-pic-option"
                              : "col-lg-4 hide-pic-option"
                          }
                        >
                          <label className="form-label">{t("EquipmentManagementScreenContent.GuideLines")}</label>
                          <br></br>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                {t("CommonText.BrowseFile")}
                                <input
                                  type="file"
                                  multiple
                                  id="files"
                                  style={{ marginRight: 40 }}
                                  name="guideAttachmentName"
                                  onChange={(e) =>
                                    this.handleInputChangeMultipleFile(e)
                                  }
                                  onClick={(event) => {
                                    event.currentTarget.value = null;
                                  }}
                                />
                              </span>
                            </div>
                            <input
                              multiple
                              type="text"
                              class="form-control"
                              placeholder=""
                              value={
                                this.state.equipmentinfo.selectedFilesGuideAttachmentName.length+' Files'
                              }
                            />
                            {this.state.equipmentinfo.guideAttachmentName ? (
                              <div
                                class="input-group-append"
                                style={{ cursor: "pointer" }}
                              >
                                <i
                                  class="fa fa-times input-group-text padding-top-9px"
                                  aria-hidden="true"
                                  onClick={() => this.ClearInput(2)}
                                ></i>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )} */}
                      {/* <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">{t("EquipmentManagementScreenContent.AddonEquipment")} </label>
                        <br></br>
                        <div className="row">
                          <div
                            className={
                              showSidePane
                                ? "col-sm-5 clsm-3"
                                : "col-sm-3 mt-2 clsm-3"
                            }
                          >
                            <input
                              type="radio"
                              name="AddEquipmentyes"
                              checked={this.state.AddEquipmentYes}
                              onChange={(e) => this.handleInputChange(e)}
                            ></input>
                            <span className="ml-1">{t("confirmAlertMessage.Yes")}</span>
                          </div>
                          <div
                            className={
                              showSidePane
                                ? "col-sm-7 clsm-9"
                                : "col-sm-9 mt-2 clsm-9"
                            }
                          >
                            <input
                              type="radio"
                              name="AddEquipmentno"
                              checked={this.state.AddEquipmentNo}
                              onChange={(e) => this.handleInputChange(e)}
                            ></input>
                            <span className="ml-1">{t("confirmAlertMessage.No")}</span>
                          </div>
                        </div>
                      </div> */}
                      {console.log(this.state.equipmentinfo?.equipmentCategoryTypeid, "this.state.equipmentinfo?.equipmentCategoryTypeid")}
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label required">
                          {/* {t("EquipmentTypeScreen.Title")} */}
                          {t("ShipEquipmentStatusScreen.Equipment")} {""} {t("ShipEquipmentStatusScreen.ContractType")}
                        </label>
                        <br></br>
                        <select
                          className="form-control"
                          id="equipmentType"
                          name="equipmentCategoryTypeid"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.equipmentinfo?.equipmentCategoryTypeid}
                        >
                          <option value="">
                            {/* {t("EquipmentManagementScreenContent.SelectEquipmentType")} */}
                            {t("content.Select")} {""} {t("ShipEquipmentStatusScreen.Equipment")} {""} {t("ShipEquipmentStatusScreen.ContractType")}
                          </option>
                          {/* <option value="1">Contract</option>
                          <option value="2">Add On</option>
                          <option value="3">Adhoc</option> */}
                          {
                            this.state.equipemntConfigTypeList?.length > 0 && this.state.equipemntConfigTypeList.map(x => {
                              return <option value={x.lookUpId}>{x.lookUpName}</option>
                            })
                          }
                        </select>
                      </div>
                      {/* <div
                        className={
                          showSidePane
                            ? "col-lg-6 hide-pic-option"
                            : "col-lg-4 hide-pic-option"
                        }
                      >
                        <label className="form-label">{'Manual'}</label>
                        <br></br>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              {t("CommonText.BrowseFile")}
                              <input
                                type="file"
                                multiple
                                id="files"
                                style={{ marginRight: 40 }}
                                name="documentname"
                                onChange={(e) =>
                                  this.handleInputChangeMultipleFile(e)
                                }
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span>
                          </div>
                          <input
                            multiple
                            type="text"
                            class="form-control"
                            placeholder=""
                            value={
                              this.state.equipmentinfo.documentname
                            }
                          />
                          {this.state.equipmentinfo.documentname ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                class="fa fa-times input-group-text padding-top-9px"
                                aria-hidden="true"
                                onClick={() => this.ClearInput(3)}
                              ></i>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div> */}
                    </div>
                    <div className="search-filter-box">
                      <div
                        className="card MM-card-header"
                        style={{ backgroundColor: "white" }}
                      >
                        <div
                          className="card-body flex"
                          style={{
                            padding: "0rem",
                            backgroundColor: "#1a3464",
                            color: "white",
                          }}
                        >
                          <h5
                            className="card-title ml-2 mt-2"
                            style={{ color: "092a51" }}
                          >
                            {t("ClassScreen.ApplicableServices")}
                          </h5>
                        </div>
                      </div>

                      <div className="row search-filter-box">
                        <div className="col-lg-4">
                          <div className="autocomplete-wrappers"
                            style={{
                              zIndex: this.state.openEquipment ? 0 : ""
                            }}>
                            <label className="form-label required">{t("ShipEquipmentStatusScreen.Make")}</label>
                            <br></br>
                            <AutocompleteField
                              contentEditable={true}
                              value={this.state.MakeAndModelDetails.makeName}
                              inputProps={{ placeholder: `${t("MakeAndModelScreen.SelectMake")}` }}
                              items={MakeList ?? []}
                              getItemValue={(item) => item.name}
                              shouldItemRender={this.renderEquipmentTitle.bind(
                                this
                              )}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${isHighlighted ? "selected-items" : ""
                                    }`}
                                >
                                  {item.name}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "makeName")
                              }
                              onSelect={(value, item) =>
                                this.handleSelectChange(
                                  value,
                                  "makeName",
                                  item.id,
                                  "makeId"
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {this.props.EquipmentMakeModelCard &&
                        this.props.EquipmentMakeModelCard.length
                        ? this.renderEquipmentCard()
                        : null}
                    </div>
                    <div className="row">
                      <div className="col-lg-12 mt-2">
                        <div
                          className="mb-2 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.UpdateEquipment()}
                          >
                            {t("EquipmentServiceTypes.Update")}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.moveClientList()}
                          >
                            {" "}
                            {t("ComplianceandBudgetScreen.Cancel")}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderEquipmentCard = () => {
    const { showSidePane, EquipmentMakeModelCard, t } = this.props;
    const isArabic = i18n.language === 'arab';
    return (
      <>
        {EquipmentMakeModelCard && EquipmentMakeModelCard.length ? (
          EquipmentMakeModelCard.map((item, index) => {
            if (!item.isDeleted) {
              return (
                <>
                  <div
                    className="card click m-3"
                    style={{
                      backgroundColor: "#f0f0f0",
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    <div className="p-3">
                      <div className="resource-list-auth-date">
                        <div className="row">
                          <div className={"col-sm-9 col-md-9 col-9 m-auto"}>
                            <div className="row">
                              <div className={"col-md-3 col-sm-3 py-1"}>
                                <span className={`${isArabic ? 'arabic' : ''}`}>
                                  <strong>{t("ComplianceandBudgetScreen.MakeName")} </strong>
                                  <strong>:</strong>
                                  {item?.makeName}{" "}
                                </span>
                              </div>
                              <div className={"col-md-3 col-sm-3 py-1"}>
                                <span className={`${isArabic ? 'arabic' : ''}`}>
                                  <strong>{t("ComplianceandBudgetScreen.ModelName")} </strong>
                                  <strong>:</strong>
                                  {item?.modelName}{" "}
                                </span>
                              </div>
                              <div className={"col-md-3 col-sm-3 py-1"}>
                                <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                                  <strong>{t("content.Servicetype")} </strong>
                                  <strong>:</strong>

                                </span>
                                {item?.serviceType}{" "}
                              </div>
                              <div className={"col-md-3 col-sm-3 py-1"}>
                                <span>
                                  <strong>{t("ComplianceandBudgetScreen.Type")}: </strong>
                                  {item?.isShore ? "Shore" : "Ship"}{" "}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className={"col-sm-3 col-md-3 col-3 m-auto"}>
                            <div
                              className="text-right"
                              style={{ marginLeft: "-5px" }}
                            >
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderedit()}
                              >
                                <i
                                  className="fa fa-edit fa-2x fa-lg click px-1 m-1"
                                  onClick={() =>
                                    this.showModal(
                                      item.Id || item.modelApplicableServiceId,
                                      false,
                                      this.state.MakeAndModellist[index].equipmentManual,
                                      this.state.MakeAndModellist[index].workProcedure,
                                      this.state.MakeAndModellist[index].guideLines
                                    )
                                  }
                                ></i>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderdelete()}
                              >
                                <i
                                  className="fa fa-trash fa-2x click px-2 m-1"
                                  onClick={() => this.deleteModel(item)}
                                ></i>
                              </OverlayTrigger>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            }
          })
        ) : (
          <>
            <div
              className="card m-3"
              style={{ overflow: "hidden", position: "relative" }}
            >
              <div class="container">
                <h6 className="resource-list-title no-item-card">
                  !--{t("CommonText.NoService")}--!
                </h6>
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  moveClientList = () => {
    fileDatas = [];
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/EquipmentManagement");
  };
}
function mapStateToProps(state) {
  return {
    EquipmentDetail: state.MasterScreenReducer.EquipmentDetail,
    EquipmentTypeList: state.MasterScreenReducer.EquipmentTypeList,
    CategoryList: state.MasterScreenReducer.CategoryList,
    Loading: state.PageLoaderReducer.loading,
    serviceTypeList: state.MasterScreenReducer.applicableServiceType || [],
    attachmentDetail: state.SidePanReducer.attachmentDetail,
    GattachmentDetail: state.SidePanReducer.GattachmentDetail,
    newdocattachment: state.SidePanReducer.newdocattachment,
    EquipmentDropdownList:
      state.MasterScreenReducer.EquipmentNameListAndId || [],
    MakeList: state.MasterScreenReducer.MakeList || [],
    ModelList: state.MasterScreenReducer.ModelList || [],
    applicableServiceTypeList:
      state.MasterScreenReducer.applicableServiceTypeList || [],
    EquipmentMakeModelCard: state.MasterScreenReducer.EquipmentMakeModel,
    EquipManualattachmentDetail: state.SidePanReducer.EquipManualattachmentDetail,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps
)(EquipmentUpdateScreen));
